<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Appointments </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Create Appointment</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <button type="button" class="btn btn-primary float-right" @click="redirectRoute('/appointments')">
                                <i class="fas fa-arrow-right"></i> All Appointments
                            </button>
                            <button type="button" class="btn btn-success float-right me-2" @click="redirectRoute('/today-appointments')">
                                <i class="fas fa-arrow-right"></i> Today Appointments
                            </button>

                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Content area -->
                    <div class="card" v-if="!loading">
                        <div class="card-header">
                            <h3 style="text-align: center;">Book An Appointment</h3>
                        </div>

                        <div class="card-body" >
                            <div class="row">
                                <!-- Appointment Area -->
                                <div class="col-md-8 border-end">
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label for="department_id" style="float: none;">Department *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.department_id"
                                                placeholder="Select Department"  
                                                @change="onChangeDepartment($event)"
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="department_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.department_id">
                                                {{errors.department_id[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="doctor_id" style="float: none;">Doctor *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.doctor_id"
                                                placeholder="Select Doctor"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="doctor_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                                @change="onChangeDoctor($event)"
                                                v-if="renderOptionComponent"
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.doctor_id">
                                                {{errors.doctor_id[0]}}
                                            </div>
                                        </div>                                        
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="appointment_date">Date *</label>
                                                <input type="date" class="form-control border" id="appointment_date" v-model="form.appointment_date" @input="onChangeDate($event.target.value)" @keypress="onkeyPress('appointment_date')" placeholder="Appointment Date"> 
                                                <div class="invalid-feedback" v-if="errors.appointment_date">
                                                    {{errors.appointment_date[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="schedule_id">Slot *</label>
                                                <select id="schedule_id" v-model="form.schedule_id" @change="onchangeSlot($event.target.value)" class="form-control border">
                                                    <option value="">Select Slot</option>
                                                    <!-- Options will be populated dynamically based on selected doctor and date -->
                                                    <option v-for="slot in slots" :key="slot.id" :value="slot.id">
                                                        {{ slot.label }} 
                                                    </option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.schedule_id">
                                                    {{errors.schedule_id[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">    
                                                <label for="appointment_time"> Appointment Time </label>
                                                <input type="time" class="form-control border" v-model="form.appointment_time" id="appointment_time" placeholder="Appointment Time">
                                                <div class="invalid-feedback" v-if="errors.appointment_time">
                                                    {{errors.appointment_time[0]}}
                                                </div>  
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <div class="form-group">    
                                                <label for="reporting_time"> Reporting Time </label>
                                                <input type="time" class="form-control border" v-model="form.reporting_time" id="reporting_time" placeholder="Reporting Time">
                                                <div class="invalid-feedback" v-if="errors.reporting_time">
                                                    {{ errors.reporting_time[0] }}
                                                </div>  
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="type">Type *</label>
                                                <select id="type" v-model="form.type" @change="onChangeType($event.target.value)" class="form-control border">
                                                    <option value="">Select Type</option>
                                                    <option value="physical"> Physical </option>
                                                    <option value="on_call"> On Call </option>
                                                    <!-- <option value="online"> Online </option> -->

                                                </select>
                                                <div class="invalid-feedback" v-if="errors.type">
                                                    {{errors.type[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr>

                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label for="patient_name" style="float: none;">Patient *</label>
                                            <input type="text" class="form-control border" v-model="form.patient_name" id="patient_name" placeholder="Patient Name Here!" @keypress="onkeyPress('patient_name')">                                                  
                                            <div class="invalid-feedback" v-if="errors.patient_name">
                                                {{errors.patient_name[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <label for="patient_phone" style="float: none;">Patient Phone </label>
                                            <input type="text" class="form-control border" v-model="form.patient_phone" id="patient_phone" placeholder="Phone number Here!" @keypress="onkeyPress('patient_phone')">                                                  
                                            <div class="invalid-feedback" v-if="errors.patient_phone">
                                                {{errors.patient_phone[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <label for="patient_age" style="float: none;">Patient Age </label>
                                            <input type="text" class="form-control border" v-model="form.patient_age" id="patient_age" placeholder="Age Here!" @keypress="onkeyPress('patient_age')">                                                  
                                            <div class="invalid-feedback" v-if="errors.patient_age">
                                                {{ errors.patient_age[0] }}
                                            </div>
                                        </div>

                                        <div class="col-md-4 mt-3">
                                            <div class="form-group">    
                                                <label for="p-status">Status *</label>
                                                <select id="p-status" v-model="form.status" class="form-control border">
                                                    <option value="0"> Pending </option>
                                                    <!-- <option value="1"> Confirmed </option> -->
                                                    <option value="2"> Present </option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.status">
                                                    {{errors.status[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="payment_area" v-if="form.type == 'physical' && form.status == 2">
                                        <hr>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="paying_by">Paying by *</label>
                                                    <select id="paying_by" v-model="form.payment_type" class="form-control border">
                                                        <option value="cash">Cash</option>
                                                        <option value="card">Card</option>
                                                    </select>
                                                    <div class="invalid-feedback" v-if="errors.payment_type">
                                                        {{errors.payment_type[0]}}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="amount">Amount *</label>
                                                    <input type="number" step="any" onmousewheel="return false" v-model="form.amount" id="amount" @keypress="onkeyPress('amount')" class="form-control" />
                                                    <div class="invalid-feedback" v-if="errors.amount">
                                                        {{errors.amount[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Appointment Schedule Area -->
                                <div class="col-md-4">
                                    <div class="card border">
                                        <div class="card-header bg-primary text-white">
                                            <h5 style="text-align: center; margin:0;">Doctor Schedule</h5>
                                        </div>
                                        <div class="card-body">
                                            <table class="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Day</th>
                                                        <th>Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="schedules.length > 0">
                                                    <tr v-for="schedule in schedules" :key="schedule.id" :class="{'table-success': schedule.isMatching}">
                                                        <td>{{ schedule.weekday }}</td>
                                                        <td>{{ new Date('1970-01-01 ' + schedule.start_time).toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: true }) }} - {{ new Date('1970-01-01 ' + schedule.end_time).toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: true }) }}</td>
                                                    </tr>
                                                    <tr v-if="schedules.filter(s => s.doctor_id === form.doctor_id).length === 0">
                                                        <td colspan="2" style="text-align: center;">No schedule available for selected doctor.</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else-if="form.doctor_id && schedules.length == 0">
                                                    <tr>
                                                        <td colspan="2" style="text-align: center;">No schedule available for selected doctor.</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="2" style="text-align: center;">No schedule available. Please select a doctor.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="card border" v-if="!editMode || (editMode && (appointment.doctor_id != form.doctor_id) || (appointment.appointment_date != form.appointment_date))">
                                        <div class="card-header bg-success text-white">
                                            <h5 style="text-align: center; margin:0;">Available Slots</h5>
                                        </div>
                                        <div class="card-body">
                                            <table class="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Time</th>
                                                        <th>Book</th>
                                                        <th>Cancel</th>
                                                        <th>Available</th>
                                                        <th>Serial</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="slot in slots" :key="slot.id" :class="{'table-success': slot.isMatching}">
                                                        <td class="fw-bold"><small>{{ slot.label }}</small></td>
                                                        <td class="text-center">{{ slot.appointments_count }}</td>
                                                        <td class="text-center">{{ slot.canceled_count }}</td>
                                                        <td class="text-center">{{ slot.available }}</td>
                                                        <td class="text-center">{{ slot.next_serial }}</td>
                                                    </tr>
                                                    <tr v-if="slots.length === 0">
                                                        <td colspan="5" style="text-align: center;">No slots available for selected date.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            
                            </div>
                        </div>

                        <div class="card-footer text-center">
                            <button type="button" class="btn btn-danger px-4 me-2" @click="resetForm()">
                                Reset
                            </button> 
                            <button type="submit" @click="submitForm" class="btn btn-primary px-4" :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span> {{btn}} 
                            </button> 
                        </div>
                    </div>

                    <div class="tab-pane show active" v-if="loading">
                        <div class="row"> 
                            <div class="col-md-5">  
                            </div>
                            <div class=" col-md-2"> 
                                <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                            </div>
                            <div class="col-md-5">  
                            </div>
                        </div>
                    </div>

                </div>
            </div> 

            <!-- Token Print Modal-->
            <!-- <Modal @close="toggleTokenPrintModal()" :modalActive="tokenPrintModalActive"> -->
            <Modal @close="toggleTokenPrintModal()">
                <div class="modal-content scrollbar-width-thin appointment-print" >
                    <div class="modal-header"> 
                        <h3 style="width: 100%">Appointment Token</h3>
                        <button style="float: right;" @click="toggleTokenPrintModal()" type="button" class="btn btn-danger">X</button>
                    </div>
                    <div class="modal-body " id="printTokenArea" >
                        <div class="appointment_token" style="text-align: center;" v-if="tokenPrintModalActive">
                            <h3 style="text-align: center;">{{ (appointment.serial_no).slice(-4) }}</h3>
                            <h5 style="text-align: center;">Patient: {{ appointment.patient_name }}</h5>
                            <p style="text-align: center;">Doctor: {{ appointment.doctor_name }}</p>
                            <p style="text-align: center;">Department: {{ appointment.department_name }}</p>
                            <p style="text-align: center;">Date: {{ appointment.appointment_date }}</p>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            tokenPrintModalActive:false,
            errors: {},
            imagePreview: '',
            btn:'Create',
            renderOptionComponent: true,
            items: [],
            appointment_id: this.$route.query.appointment_id || null,
            app_query_type: this.$route.query.type || null,
            appointment: {},
            appointments: [],
            patients: [],
            patient_options: [],
            doctors: [],
            doctor_options: [],
            departments: [],
            department_options: [],
            schedules: [],
            slots: [],
            loading: true,
            companies: [],
            form: new Form({
                id: '',
                department_id: '',
                doctor_id: '',
                appointment_date: '', 
                schedule_id: '',
                appointment_time: '',
                reporting_time: '',  
                type: 'physical',
                patient_id: '', 
                patient_name: '', 
                patient_phone: '', 
                patient_age: '',
                status: 2,
                payment_type: 'cash',
                amount: '',
            }),
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },

        };
    },
    created() {
        this.fetchDepartments();
        this.fetchDoctors();
        if(this.appointment_id) {
            this.onLoadAppointment(this.appointment_id);
        }

        // console.log("appointment_id==", this.$route.query);
    },
    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        redirectRoute(url) {
            this.$router.push({ path: url });
        },


         
        toggleTokenPrintModal: function() {  
            this.tokenPrintModalActive = !this.tokenPrintModalActive;
            // if(this.tokenPrintModalActive) {
                setTimeout(() => {
                    this.printContent('printTokenArea');
                    this.tokenPrintModalActive = false;
                }, 2000);
            // }
        },

        tokenPrint: function(item) {  
            this.appointment = item;
            this.toggleTokenPrintModal();
        },

        printContent(document_id) { 
            const width = 900;
            const height = 650;
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);

            const options = {
                name: '_blank',
                specs: [
                    `width=${width}`,
                    `height=${height}`,
                    `top=${top}`,
                    `left=${left}`,
                    'scrollbars=yes',
                    'resizable=yes',
                    'titlebar=yes'
                ],
                styles: [
                    this.baseUrlPrintCSS + '/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS + '/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

        async fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 

        async fetchPatients() { 
            axios.get(this.apiUrl+'/hm/patients', this.headerjson)
            .then((res) => {
                this.patients = res.data.data;
                // this.patient_options = [{label: "Select Patient", value: ""}];
                res.data.data.map((item) => {
                    this.patient_options.push({label:item.name + " - " + item.phone, value:item.id});
                }); 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        }, 
        async fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                this.departments = res.data.data; 
                // this.department_options = [{label: "Select Department", value: ""}];
                res.data.data.map((item) => {
                    this.department_options.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 

        async fetchDoctors() {
            axios.get(this.apiUrl+"/hm/doctors", this.headerjson)
            .then((resp) => {
                this.doctors  = resp.data.data;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        onChangeDepartment(dept_id) {
            this.schedules = [];
            this.form.department_id = dept_id;
            this.doctor_options = [];
            this.form.doctor_id = '';
            this.form.appointment_date = '';
            this.slots = [];
            this.form.schedule_id = '';
            this.form.appointment_time = '';
            this.form.reporting_time = '';
            this.form.type = 'physical';
            this.forceRerender();
            if(dept_id != 0) {
                let department_doctors = this.doctors.filter((item, index) => {
                    return item.department_id == dept_id;
                });

                if(department_doctors.length > 0) {
                    this.doctor_options = department_doctors.map((item) => { 
                        return {label:item.name, value:item.id};
                    });
                }
            }

        },

        onChangeDoctor(val) {
            this.schedules = [];
            this.form.doctor_id = val;
            this.form.appointment_date = '';
            this.slots = [];
            this.loadSchedules();
        },

        onChangeDate(val) {
            this.slots = [];
            this.form.schedule_id = '';
            this.form.appointment_date = val;
            this.form.appointment_time = '';
            this.form.reporting_time = '';
            this.loadSlots();
            this.highlightMatchingSchedule('schedule');
        },

        onchangeSlot(val) {
            this.form.schedule_id = val;
            this.appointment_time = '';
            this.reporting_time = '';
            this.appointmentTimeSchedule();
            this.highlightMatchingSchedule('slot');
        },

        onChangeType(val) {
            this.form.type = val;
            if(val != 'physical') {
                this.form.payment_type = '';
                this.form.amount = '';
                this.form.status = 0;
            }else{
                this.form.payment_type = 'cash';
                this.form.status = 2;
            }
        },

        appointmentTimeSchedule() {
            let selectedSlot = this.slots.find(slot => slot.id == this.form.schedule_id);

            console.log(selectedSlot, this.form.schedule_id);

            if (selectedSlot) {
                // Set appointment time based on slot start time and patient count
                const slotStartTime = new Date(`1970-01-01 ${selectedSlot.start_time}`);
                const slotEndTime = new Date(`1970-01-01 ${selectedSlot.end_time}`);
                const slotDurationMs = slotEndTime.getTime() - slotStartTime.getTime();
                const patientCount = selectedSlot.appointments_count || 0;
                const timePerPatient = slotDurationMs / (selectedSlot.available + patientCount);
                const appointmentTime = new Date(slotStartTime.getTime() + (patientCount * timePerPatient));
                this.form.appointment_time = appointmentTime.toLocaleTimeString('en-US', { 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: false 
                }).substring(0, 5);
                
                // Calculate reporting time (15 minutes before appointment time)
                const reportingTime = new Date(appointmentTime.getTime() - 15 * 60000);
                this.form.reporting_time = reportingTime.toLocaleTimeString('en-US', { 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: false 
                }).substring(0, 5);
            }

            console.log("sdfsjhdjf==", this.form.appointment_time, this.form.reporting_time);
        },

        highlightMatchingSchedule(type) {

            if(type === 'slot') {
                const selectedSlot = this.slots.find(slot => slot.id == this.form.schedule_id);
                if (!selectedSlot) return;
                this.slots = this.slots.map(slot => {
                    return {
                        ...slot,
                        isMatching: slot.id == this.form.schedule_id
                    };
                });
            }
            else if(type === 'schedule') {
                const selectedDate = new Date(this.form.appointment_date);
                const options = { weekday: 'short' };
                const selectedWeekday = selectedDate.toLocaleDateString('en-US', options);
                this.schedules = this.schedules.map(schedule => {
                    return {
                        ...schedule,
                        isMatching: schedule.weekday == selectedWeekday
                    };
                });
            }
            else {
                this.schedules = this.schedules.map(schedule => {
                    return {
                        ...schedule,
                        isMatching: false
                    };
                });
                this.slots = this.slots.map(slot => {
                    return {
                        ...slot,
                        isMatching: false
                    };
                });
            }
            
        },

        async onLoadAppointment(appointment_id) {
            if(!appointment_id) return;
            this.editMode = true;
            this.btn='Update';
            const res = await axios.get(this.apiUrl +'/hm/appointments/'+appointment_id, this.headerjson);
            this.appointment = res.data.data;
            this.form.fill(res.data.data); 
            if(this.form.department_id != 0) {
                let department_doctors = this.doctors.filter((item, index) => {
                    return item.department_id == this.form.department_id;
                });

                if(department_doctors.length > 0) {
                    this.doctor_options = department_doctors.map((item) => { 
                        return {label:item.name, value:item.id};
                    });
                }
            }
            this.loadSchedules();
            this.loadSlots();
            setTimeout(() => {
                this.highlightMatchingSchedule('schedule');
                this.highlightMatchingSchedule('slot');
            }, 1000);
        },

        async loadSchedules () {
            if (!this.form.doctor_id) return;
            const res = await axios.get(this.apiUrl +"/hm/doctor_schedules", {
                params: { doctor_id: this.form.doctor_id },
                ...this.headerjson
            });
            console.log(res.data.data);
            this.schedules = res.data.data;
        },

        async loadSlots() {
            if (!this.form.doctor_id || !this.form.appointment_date) return;
            const response = await axios.get(this.apiUrl +'/hm/doctor-slots', {
                params: { doctor_id: this.form.doctor_id, date: this.form.appointment_date },
                ...this.headerjson
            });
            this.slots = response.data.data;
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            let department_doctors = this.doctors.filter((doctor, index) => {
                    return doctor.department_id == item.department_id;
            });

            if(department_doctors.length > 0) {
                this.doctor_options = department_doctors.map((item) => { 
                    return {label:item.name, value:item.id};
                });
            }

            this.form.fill(item);  
        },

        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();                        
            formData.append('department_id', this.form.department_id);
            formData.append('doctor_id', this.form.doctor_id);
            formData.append('appointment_date', this.form.appointment_date);
            formData.append('schedule_id', this.form.schedule_id);
            formData.append('appointment_time', this.form.appointment_time);
            formData.append('reporting_time', this.form.reporting_time);
            formData.append('type', this.form.type);
            formData.append('patient_id', this.form.patient_id);
            formData.append('patient_name', this.form.patient_name);
            formData.append('patient_phone', this.form.patient_phone);
            formData.append('patient_age', this.form.patient_age);
            formData.append('status', this.form.status);
            formData.append('payment_type', this.form.payment_type);
            formData.append('amount', this.form.amount);

            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/hm/appointments/'+this.form.id, formData, this.headers);
            }else{  
                var postEvent = axios.post(this.apiUrl+'/hm/appointments', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.appointment = res.data.data;
                    if(this.appointment.status == 2 && !this.editMode) {
                        this.toggleTokenPrintModal();
                    }
                    this.$toast.success(res.data.message); 
                    if((this.app_query_type == 'today' || this.app_query_type == 'all') && this.appointment.appointment_date == new Date().toISOString().slice(0, 10)) {
                        this.redirectRoute('/today-appointments');
                    }else if(this.app_query_type != null) {
                        this.redirectRoute('/appointments');
                    }

                }else{
                    this.$toast.error(res.data.message);
                } 
                this.resetForm();
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        resetForm() {
            this.editMode = false;
            this.btn = 'Create';
            this.form.reset();
            this.errors = {};
            this.schedules = [];
            this.slots = [];
            this.forceRerender();
            if(this.appointment_id) {
                this.onLoadAppointment(this.appointment_id);
            }
        },

        // For Pagination 
        getAppointmentList(url = this.apiUrl+'/hm/appointments/list') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.appointments = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 700px
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>